/**
 * This component generates a nav bar with 3 parts.
 * [Back/Menu button, HeaderText/Bluecrew Logo, closing modal or returning to app-home]
 */

import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})


export class NavigationBarComponent implements OnInit {

  @Input() headerText?: string;
  @Input() leftButton?: leftButtonValues;
  @Input() rightButton?: rightButtonValues;

  constructor(private navCtrl: NavController,
              private modalCtrl: ModalController) { }

  ngOnInit() {}


  // TODO: parameterize these to allow navigation to be wherever needed.
  navigateHome(): void {
    this.navCtrl.navigateBack(AppRoutingUtil.HOME);
  }

  dismissModal(): void {
    this.modalCtrl.dismiss();
  }
}

enum leftButtonValues {
  previous,
  menu
}

enum rightButtonValues {
  dismissModal,
  navigateHome
}
